// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1vByJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__D_7mp"};